export const DashboardEDF = {
  title: 'Pedidos EDF'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardEDF.js